"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocalLicenceValidation = exports.validateLocalLicence = exports.validateField = void 0;
const react_1 = __importDefault(require("react"));
const ValidationContext_1 = require("../../context/ValidationContext");
const config_1 = require("../../view/pages/tasks/local-licence/config");
const generateFieldName = (fieldName) => {
    return fieldName.split('_').map((v) => v[0].toUpperCase() + v.slice(1)).join(' ');
};
const validateField = (field, localLicence, reqs) => {
    var _a, _b, _c;
    const fieldReqs = (_a = reqs === null || reqs === void 0 ? void 0 : reqs.validation) === null || _a === void 0 ? void 0 : _a[field];
    if (!fieldReqs) {
        return [true];
    }
    if (fieldReqs.skipIfOtherFieldValues !== undefined) {
        const skipConditionsAllMatch = Object.entries(fieldReqs.skipIfOtherFieldValues).every(([k, v]) => (localLicence === null || localLicence === void 0 ? void 0 : localLicence[k]) === v);
        if (skipConditionsAllMatch) {
            return [true];
        }
    }
    const friendlyName = (_c = (_b = reqs.fieldAliases) === null || _b === void 0 ? void 0 : _b[field]) !== null && _c !== void 0 ? _c : generateFieldName(field);
    const errorMessage = `Please provide a valid ${friendlyName}`;
    const value = localLicence === null || localLicence === void 0 ? void 0 : localLicence[field];
    if (!value) {
        return [false, errorMessage];
    }
    const minReq = fieldReqs.min;
    if (minReq !== undefined) {
        const valid = value.length >= minReq;
        if (!valid) {
            return [false, errorMessage];
        }
    }
    const maxReq = fieldReqs.max;
    if (maxReq !== undefined) {
        const valid = value.length <= maxReq;
        if (!valid) {
            return [false, errorMessage];
        }
    }
    const regexReq = fieldReqs.regex;
    if (regexReq !== undefined) {
        const valid = String(value).match(regexReq);
        if (!valid) {
            return [false, errorMessage];
        }
    }
    return [true];
};
exports.validateField = validateField;
const validateLocalLicence = (property) => {
    var _a;
    const { country_code, local_licence } = property;
    const licenceReqs = (0, config_1.getLicenceRequirements)(config_1.LocalLicenceCountries[country_code]);
    const hasValidationRequirements = Object.keys((_a = licenceReqs === null || licenceReqs === void 0 ? void 0 : licenceReqs.validation) !== null && _a !== void 0 ? _a : {}).length > 0;
    if (!licenceReqs || !hasValidationRequirements) {
        return { valid: true, fields: {} };
    }
    const allFieldsValidation = Object.keys((licenceReqs.validation)).reduce((all, currentKey) => {
        var _a;
        if ((_a = licenceReqs === null || licenceReqs === void 0 ? void 0 : licenceReqs.validation) === null || _a === void 0 ? void 0 : _a[currentKey]) {
            all[currentKey] = (0, exports.validateField)(currentKey, local_licence, licenceReqs)[0];
        }
        return all;
    }, {});
    return { fields: allFieldsValidation, valid: Object.keys(allFieldsValidation).every((k) => allFieldsValidation[k]) };
};
exports.validateLocalLicence = validateLocalLicence;
/**
 * A hook to power validating a local licence field as it changes, and sync its validity to the ValidationContext.
 * @param field - A key of a local licence to validate
 * @param property - The property the local licence is for
 * @returns {FieldValidation}
 */
const useLocalLicenceValidation = (field, property) => {
    const validationContext = react_1.default.useContext(ValidationContext_1.ValidationContext);
    const [validState, setValid] = react_1.default.useState([true]);
    const fieldContextState = validationContext.state.local_licence.fields[field];
    react_1.default.useEffect(() => {
        var _a;
        const licenceReqs = (0, config_1.getLicenceRequirements)(config_1.LocalLicenceCountries[property.country_code]);
        const fieldReqs = (_a = licenceReqs === null || licenceReqs === void 0 ? void 0 : licenceReqs.validation) === null || _a === void 0 ? void 0 : _a[field];
        if (!licenceReqs || !fieldReqs) {
            setValid([true]);
            return;
        }
        const [valid, errMsg] = (0, exports.validateField)(field, property.local_licence, licenceReqs);
        if (valid !== fieldContextState) {
            validationContext.dispatch(ValidationContext_1.validationActions.updateLocalLicence(field, valid));
        }
        setValid([valid, errMsg]);
    }, [property.country_code, property.local_licence]);
    return validState;
};
exports.useLocalLicenceValidation = useLocalLicenceValidation;
//# sourceMappingURL=local-licence.js.map